import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d39adfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "写真アップロード時に、以下の点をご注意ください。", -1))
const _hoisted_2 = { class: "text-weight-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CautionArea = _resolveComponent("CautionArea")!

  return (_openBlock(), _createBlock(_component_CautionArea, { cautionMessage: "写真の不備による審査落ちが増えています" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ol", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cautions, (caution) => {
            return (_openBlock(), _createElementBlock("li", { key: caution }, _toDisplayString(caution), 1))
          }), 128))
        ]),
        _createTextVNode(),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ], undefined, true),
    _: 3
  }))
}